import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as USER_FRIEND_TYPE} from '../creators/user.friend';

export function* deleteSuccess(action) {
    try {
        yield put({type: "USER_FRIENDS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "USER_FRIENDS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchFriend() {
    yield takeEvery(USER_FRIEND_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(USER_FRIEND_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchFriend;

